// extracted by mini-css-extract-plugin
export default {"title":"CheckEmail_title__UQ5MS","subtitle":"CheckEmail_subtitle__0aXy0","email":"CheckEmail_email__lldM1","button":"CheckEmail_button__dVb8h"};